export enum ServiceName {
  MEETING = "Mile Meeting",
  VISITORS = "Mile Visitors",
}

export enum Plan {
  FREE = "무료",
  BASIC = "유료",
}

export enum MileMeetingPlan {
  FREE = 0,
  PAID_NOT_TABLET = 1,
  PAID_TABLET = 2,
  EARLYBIRD = 3,
}

export interface ServicePlanCardProps {
  serviceName: ServiceName; //* 서비스명
  plan?: Plan; //* 플랜 종료
  usedTablet: boolean; //* 태블릿 사용 여부
  planStartedAt?: string; //* 이용 기간 시작일
  planEndedAt?: string; //* 이용 기간 종료일
  enableMeetingRoom?: number; //* 생성 가능 회의실 수
  usingMeetingRoom?: number; //* 사용 중 회의실 수
}
